import React, { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

export default function ScrollUpButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div
      className={`fixed bottom-24 right-6 z-40 transition-all duration-300 ${
        isVisible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <button
        type="button"
        onClick={scrollToTop}
        aria-label="Scroll to top"
        title="Kembali ke atas"
        className="w-12 h-12 rounded-2xl bg-gray-900/90 hover:bg-gray-900 text-white shadow-xl hover:shadow-2xl hover:-translate-y-1 backdrop-blur-md border border-gray-700/50 flex items-center justify-center transition-all duration-300 group focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <ArrowUp className="w-5 h-5 group-hover:-translate-y-1 transition-transform duration-300" />
      </button>
    </div>
  );
}
